export default function Introduction() {
    return (
        <>
        <div class="Introduction-IB"></div>
        <section class="Introduction">
                <div class="I one">
                    <h1 class="Title">Trusted experienced tutors</h1>
                    <p class="Description">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec lobortis purus nec libero ultricies, et ultricies arcu euismod. Donec scelerisque consectetur dapibus. Mauris posuere dolor ac metus dapibus, tincidunt fermentum massa dictum.</p>
                </div>
                <div class="I two">
                    <h1 class="Title">Broad subjects covered</h1>
                    <p class="Description">Lorem ipsum dolor sit amet, consectetur adipiscing elit. Donec lobortis purus nec libero ultricies, et ultricies arcu euismod. Donec scelerisque consectetur dapibus. Mauris posuere dolor ac metus dapibus, tincidunt fermentum massa dictum.</p>
                </div>
        </section>
        </>
    )
}